import React from "react";

const DecisionMakersInfoView = ({ decisionInfo }) => {
  if (!decisionInfo) {
    return null;
  }

  return (
    <div className="form-row">
      <div className="form-row-item">
        <div className="form-element-data date">
          <div className="form-element-data-text">
            <p>{decisionInfo}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DecisionMakersInfoView;
